<template>
    <div class="basket" :class="{ 'active' : isBasketOpen }">
        <div class="basket_title">
            Корзина <a href="javascript:void(0)" class="basket_close" @click="close"></a>
        </div>
        <div class="basket_list" >
            <div class="basket_item" v-for="item in basketItems" :key="item.id" >
                <div class="basket_item_img" v-if="item.additional_params">
                    <img :src="item.list_image" alt="" />
                </div>
                <div class="basket_item_box">
                    <a :href="'/catalog/item/'  + item.id + (item.human_url ? '/' + item.human_url : '')" class="basket_item_name">
                        {{ item.name }}
                    </a>
                    <div class="basket_item_price">
                        {{ item.current_price.amount  | priceFormat }} ₽
                        <span v-if="item.has_discount"> {{ item.base_price.amount  | priceFormat }} ₽</span>
                    </div>
                    <div class="basket_item_buts">
                        <div class="basket_item_count">
                            <a href="javascript:void(0)" class="less" @click="decrement(item.id)"></a>
                            <span class="count"> {{ item.count }} </span>
                            <a href="javascript:void(0)" class="more"  @click="increment(item.id)"></a>
                    </div>
                    <a href="javascript:void(0);" class="basket_item_remove"  @click="remove(item.id)"> Удалить </a></div>
                </div>
            </div>
            <div class="basket_item deleted" v-for="item in shadowBasket" :key="item.id" >
                <div class="basket_item_img" v-if="item.additional_params">
                    <img :src="item.list_image" alt="" />
                </div>
                <div class="basket_item_box">
                    <a :href="'/catalog/item/'  + item.id + (item.human_url ? '/' + item.human_url : '')" class="basket_item_name">
                        {{ item.name }}
                    </a>
                    <div class="basket_item_price">
                        {{ item.current_price.amount  | priceFormat }} ₽
                        <span v-if="item.has_discount"> {{ item.base_price.amount  | priceFormat }} ₽</span>
                    </div>
                    <div class="basket_item_buts">
                        <div class="basket_item_count">
                            <span class="count"> {{ item.count }} </span>
                    </div>
                    <a href="javascript:void(0);" class="basket_item_remove"  @click="addToBasket(item.id)"> Восстановить </a></div>
                </div>
            </div>
            <div class="basket_result">
                <div class="basket_result_value">
                    Итого
                    <span> {{ total  | priceFormat }} ₽ </span>
                </div>
                <div class="basket_result_buts" v-if="basketItems.length">
                    <a href="/customer/basket" class="btn btn-orange"> Оформить заказ </a>
                    <a href="/catalog/top" class="btn btn-gray"> Продолжить покупки </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BasketFloat",
        data () {
          return {
            shadowBasket: []
          }
        },
        computed: {
            basketItems () {
              return this.$store.state.basket;
            },
            isBasketOpen () {
                return this.$store.state.isBasketOpen
            },
            total () {
                return this.$store.getters.basketTotal
            }
        },
        methods: {
            increment (id) {
                this.$store.commit('incrementBasket', id)
            },
            decrement (id) {
                this.$store.commit('decrementBasket', id)
            },
            remove (id) {
                this.shadowBasket.push(this.$store.state.basket.find(item => item.id === id))
                this.$store.commit('removeFromBasket', id)
            },
            addToBasket(id) {
              this.$store.commit('addToBasket', this.shadowBasket.find(item => item.id === id));
              this.shadowBasket = this.shadowBasket.filter(item => item.id !== id)
            },
            close() {
                this.$store.state.isBasketOpen=false
            }

        }
    }
</script>

<style scoped>
.deleted {
  background: #f8f8f8;
}

.deleted .basket_item_name {
  text-decoration: line-through;
  color: grey!important;
}
</style>